import { useEffect, useState } from 'react';

import { SEARCH_DEBOUNCE_TIME_MS } from '@/app/constants';

const useDebounce = <T>(initialValue: T, delay = SEARCH_DEBOUNCE_TIME_MS) => {
  const [value, setValue] = useState<T>(initialValue);
  const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return { debouncedValue, value, setValue, forceSetValue: setDebouncedValue };
};

export default useDebounce;
